import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Row, Col } from '@mch-group/uikit-components'
import { useBackNavigation } from '@hooks'

import { px2rem } from '@utils'
import { Loader } from '@components'
import IntersectionCapture from '@reusable-modules/IntersectionCapture'
import RoomCard from '@components/reusable-modules/OS/components/tabs/Rooms/RoomCard'
import useCollectionUtils from '@modules/collections/hooks/useCollectionUtils'
import { useMyCollectionsPageContext } from '@modules/collections/contexts/useMyCollectionsPageContext'
import TabContentHeader from '../TabContentHeader'

const RoomsTab = (props) => {
  const {
    editPreviewCollectionItems,
    isRefreshing,
    isEmpty,
    isLoadingInitialData,
    editPreviewCollectionItemsValidating,
    setSize,
    size,
    isLoadingMore,
    totalItems,
    isTabExist
  } = props
  //@ts-ignore
  const [{ labels, isOrganizeMode, selectedItems }] = useMyCollectionsPageContext()
  const { onSelectCard } = useCollectionUtils()
  const { keys } = useBackNavigation()

  const isIntersectionActive =
    editPreviewCollectionItems &&
    !editPreviewCollectionItemsValidating &&
    !isRefreshing &&
    !isEmpty &&
    !isLoadingInitialData &&
    !isLoadingMore

  return (
    <div>
      <TabContentHeader
        total={totalItems}
        counterSubText={labels.Collections.viewingRoomCountLabel}
        isTabExist={isTabExist}
      />
      {editPreviewCollectionItems.length > 0 && (
        <>
          <Row>
            {editPreviewCollectionItems.map((room, index) => {
              const hasArtworkNotAvailable = Object.values(room.status).some((item) => item === true)
              return (
                <Col xs={12} sm={12} md={6} lg={4} xl={3} xxl={3} className='mb-lg-8 mb-md-8 d-flex' key={room.id}>
                  {!hasArtworkNotAvailable ? (
                    <RoomCard
                      item={room?.item}
                      isOrganizeMode={isOrganizeMode}
                      //@ts-ignore
                      index={index}
                      isCollectionCard
                      navigationKey={keys.COLLECTION.INSIDE_MY_COLLECTION}
                      onSelectCard={onSelectCard}
                      isSelectedInCollections={
                        typeof selectedItems?.find((x) => x.entityId?.toString() === (room.id?.toString() || room?.entityId?.toString())) !== 'undefined'
                      }
                    />
                  ) : (
                    <RoomCard
                      item={room?.summary}
                      // @ts-ignore
                      index={index}
                      unavailableToView={!room?.status?.forbidden} // this is because we show opening soon in case of upcoming show
                      isCollectionCard
                      navigationKey={keys.COLLECTION.INSIDE_MY_COLLECTION}
                      openingSoon={room?.status?.forbidden}
                      entityId={room?.entityId}
                      isOrganizeMode={isOrganizeMode}
                      onSelectCard={onSelectCard}
                      isSelectedInCollections={
                        typeof selectedItems?.find((x) => x.entityId?.toString() === (room.id?.toString() || room?.entityId?.toString())) !== 'undefined'
                      }
                    />
                  )}
                </Col>
              )
            })}
          </Row>

          <IntersectionCapture
            onIntersect={() => setSize(size + 1)}
            active={isIntersectionActive}
            params={{ rootMargin: '400px' }}
          />
        </>
      )}
      {(isLoadingInitialData || isLoadingMore) && (
        <LoaderContainer>
          {/* @ts-ignore */}
          <Loader centered active />
        </LoaderContainer>
      )}
    </div>
  )
}

RoomsTab.propTypes = {
  editPreviewCollectionItems: PropTypes.array,
  isRefreshing: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  isEmpty: PropTypes.bool,
  isLoadingInitialData: PropTypes.bool,
  editPreviewCollectionItemsValidating: PropTypes.bool,
  setSize: PropTypes.func,
  size: PropTypes.number,
  isLoadingMore: PropTypes.bool,
  totalItems: PropTypes.number,
  isTabExist: PropTypes.bool
}

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: ${px2rem(100)};
`
export default RoomsTab
